module.exports = __webpack_public_path__ + "img/7_58.9dfa4686.png";